import * as React from "react";

import { UitkPrimaryFloatingButton, UitkButtonSize } from "uitk-react-button";
import { UitkDialogContent, UitkFullscreenDialog, UitkDialogAnimationType } from "uitk-react-dialog";
import { UitkRadioGroup, UitkRadio } from "uitk-react-switch";
import { UitkText } from "uitk-react-text";
import { UitkToolbar, ToolbarType } from "uitk-react-toolbar";

import { useLocalization } from "@shared-ui/localization-context";

import { locKeys } from "components/flexComponents/WizardCruisePWA/l10n";
import { IDestinationGroups, IDestinationGroup } from "./destinations";

export interface CruiseDestinationDialogProps {
  destinationGroups: IDestinationGroups;
  onDismiss: () => void;
  onSave: (destinationValue: string, destinationForDisplay: string) => void;
  queryRouteId: string;
}

export const CruiseDestinationDialog: React.FC<CruiseDestinationDialogProps> = (props) => {
  const { formatText } = useLocalization();

  const [destinationValue, setDestinationValue] = React.useState("");
  const [destinationForDisplay, setDestinationForDisplay] = React.useState("");

  const onDoneButtonClick = () => {
    props.onSave(destinationValue, destinationForDisplay);
  };

  const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value, labels } = event.currentTarget;
    const [label] = labels;

    setDestinationValue(value);
    setDestinationForDisplay(label.textContent as string);
  };

  return (
    <UitkFullscreenDialog dialogShow animation={UitkDialogAnimationType.SLIDEUP}>
      <UitkToolbar
        action={props.onDismiss}
        iconLabel={formatText(locKeys.dismissDialog)}
        type={ToolbarType.CLOSE}
        header={formatText(locKeys.destinationLabel)}
      />

      <UitkDialogContent zeroPadding={false} className="all-l-margin-two">
        {Object.keys(props.destinationGroups).map((groupKey) => {
          const group: IDestinationGroup = props.destinationGroups[groupKey];

          return (
            <section key={groupKey} className="all-y-padding-three">
              <UitkText size={400} weight="bold" className="all-y-padding-three">
                {formatText(group.locKey)}
              </UitkText>

              <UitkRadioGroup group="cruise-destination-group" onChange={handleRadioChange} selected={destinationValue}>
                {group.items.map(({ value, locKey }) => (
                  <UitkRadio
                    key={`cruise-destination-radio-${value}`}
                    id={`cruise-destination-radio-${value}`}
                    value={value}
                    label={formatText(locKey)}
                  />
                ))}
              </UitkRadioGroup>
            </section>
          );
        })}
      </UitkDialogContent>

      <footer className="all-x-padding-three all-y-padding-three">
        <UitkPrimaryFloatingButton
          onClick={onDoneButtonClick}
          className="cruise-destination-dialog-confirm"
          text={formatText(locKeys.dialogDoneButton)}
          subText={destinationForDisplay}
          size={UitkButtonSize.LARGE}
          isFullWidth
          data-testid="cruise-destination-dialog-confirm"
        />
      </footer>
    </UitkFullscreenDialog>
  );
};
